import { render, staticRenderFns } from "./WorkflowsPage.vue?vue&type=template&id=d8fab654&"
import script from "./WorkflowsPage.vue?vue&type=script&lang=js&"
export * from "./WorkflowsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports